export default "__VITE_ASSET__L6mGznOp__"